import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Camera, Edit2, UserRound } from "lucide-react";
import AppModal from "../../components/AppModal";
import ResourcePage from "../../components/ResourcePage";
import { fetchUserProfile, updateUserProfile } from "../../redux/userSlice";
import { fileUrl } from "../../utils/files";
import { notify } from "../../utils/toastAlert";

const closeModal = (id) => {
  const element = document.getElementById(id);
  if (!element || !window.bootstrap) return;
  window.bootstrap.Modal.getOrCreateInstance(element).hide();
};

const UserProfile = () => {
  const dispatch = useDispatch();
  const { user, loading, error } = useSelector((state) => state.user);
  const [form, setForm] = useState({ nome: "", email: "", telefone: "", senha: "" });
  const [foto, setFoto] = useState(null);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    setForm({
      nome: user?.nome || "",
      email: user?.email || "",
      telefone: user?.telefone || "",
      senha: "",
    });
  }, [user]);

  const handleChange = (event) => {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (key !== "senha" || value) data.append(key, value);
    });
    if (foto) data.append("foto", foto);

    const result = await dispatch(updateUserProfile(data));

    if (updateUserProfile.fulfilled.match(result)) {
      await notify("Perfil actualizado com sucesso.", "success");
      setFoto(null);
      closeModal("userProfileModal");
    } else {
      await notify(result.payload || "Não foi possível actualizar o perfil.", "error");
    }
  };

  return (
    <ResourcePage
      title="Perfil do Utilizador"
      breadcrumb={["Definições", "Perfil do Utilizador"]}
      actions={(
        <button className="btn btn-primary btn-sm d-inline-flex align-items-center gap-1" type="button" data-bs-toggle="modal" data-bs-target="#userProfileModal">
          <Edit2 size={16} />
          Editar perfil
        </button>
      )}
    >
      <div className="card app-card bg-white">
        <div className="card-body">
          {error && <div className="alert alert-danger py-2">{error}</div>}
          <div className="profile-summary">
            <div className="profile-avatar">
              {user?.foto ? <img src={fileUrl(user.foto)} alt={user.nome} /> : <UserRound size={38} />}
            </div>
            <div>
              <h4 className="mb-1">{user?.nome || "Utilizador"}</h4>
              <p className="text-muted mb-0">{user?.email || "-"}</p>
              <span className="badge bg-primary-subtle text-primary mt-2">{user?.nivel || "utilizador"}</span>
            </div>
          </div>
        </div>
      </div>

      <AppModal
        id="userProfileModal"
        title="Editar perfil do utilizador"
        footer={(
          <>
            <button type="button" className="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <button type="submit" className="btn btn-primary" form="userProfileForm" disabled={loading}>
              {loading ? "A guardar..." : "Guardar"}
            </button>
          </>
        )}
      >
        <form id="userProfileForm" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="profile_nome">Nome</label>
              <input className="form-control" id="profile_nome" name="nome" value={form.nome} onChange={handleChange} required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="profile_email">Email</label>
              <input className="form-control" id="profile_email" name="email" type="email" value={form.email} onChange={handleChange} required />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="profile_telefone">Telefone</label>
              <input className="form-control" id="profile_telefone" name="telefone" value={form.telefone} onChange={handleChange} />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label" htmlFor="profile_senha">Nova senha</label>
              <input className="form-control" id="profile_senha" name="senha" type="password" value={form.senha} onChange={handleChange} placeholder="Preencha apenas se quiser alterar" />
            </div>
            <div className="col-12">
              <label className="form-label" htmlFor="profile_foto">Foto</label>
              <div className="input-group">
                <span className="input-group-text"><Camera size={16} /></span>
                <input className="form-control" id="profile_foto" name="foto" type="file" accept="image/png,image/jpeg,image/webp" onChange={(event) => setFoto(event.target.files?.[0] || null)} />
              </div>
            </div>
          </div>
        </form>
      </AppModal>
    </ResourcePage>
  );
};

export default UserProfile;
